module.exports = __webpack_public_path__ + "static/media/googleplay.3ba2d16d.png";